import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime-corejs3/helpers/objectWithoutPropertiesLoose";
import { PrivateCheckbox } from "../checkbox";
import { withProps, mapProps, compose, setDisplayName } from 'react-recompose';
var Radio = compose(setDisplayName('Radio'), withProps({
  _display: 'radio'
}), mapProps(function (_ref) {
  var isSelected = _ref.isSelected,
      rest = _objectWithoutPropertiesLoose(_ref, ["isSelected"]);

  return _extends({
    isChecked: isSelected
  }, rest);
}))(PrivateCheckbox);
export default Radio;
/*
 label:       PropTypes.string, // Stardust does not provide support for more custom labels. Can only be applied to the right
 description: PropTypes.string,
 value:       PropTypes.string.isRequired,
 onChange:    PropTypes.func.isRequired,
 isSelected:  PropTypes.oneOfType([ PropTypes.bool, PropTypes.func ]),
 isDisabled:  PropTypes.oneOfType([ PropTypes.bool, PropTypes.func ]),
 isCompact:   PropTypes.bool
 */
//# sourceMappingURL=index.js.map